import React from "react";
import { history } from "../../store/store";
import * as Yup from "yup";
import Avatar from "@mui/material/Avatar";
import Button from "@mui/material/Button";
import { Link } from "react-router-dom";
import Box from "@mui/material/Box";

import TextField from "@mui/material/TextField";
import LockIcon from "@mui/icons-material/LockOutlined";
import Paper from "@mui/material/Paper";
import Typography from "@mui/material/Typography";
import { Formik } from "formik";
import { apiClient } from "../../api/apiClient";
import { route as signInRoute } from "../SignInContainer/SignInContainer";
import { useIntl } from "react-intl";
import { Divider } from "@mui/material";

// Styles are applied via the `sx` prop on MUI components below.

const PasswordLostValidationScheme = Yup.object().shape({
  email: Yup.string().email().required(),
});

// Using Formik hook instead of withFormik HOC

const PasswordLostForm = () => {
  const { formatMessage } = useIntl();

  return (
    <Box
      component="main"
      sx={{
        pt: 8,
        width: "auto",
        display: "block",
        mx: 3,
        "@media (min-width:448px)": {
          width: 400,
          mx: "auto",
        },
      }}
    >
      <Paper
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          pt: 2,
          px: 3,
          pb: 3,
        }}
      >
        <Avatar sx={{ m: 1, bgcolor: "secondary.main" }}>
          <LockIcon />
        </Avatar>
        <Typography variant="h5">
          {formatMessage({ id: "app.forgot.password" })}
        </Typography>

        <Formik
          initialValues={{ email: "" }}
          validationSchema={PasswordLostValidationScheme}
          onSubmit={async (values, { setSubmitting, resetForm }) => {
            const { email } = values;
            setSubmitting(true);
            try {
              const response = await apiClient().post(
                "accounts/_beginPasswordReset",
                {
                  emailAddress: email,
                },
              );
              if (response.status === 200) {
                resetForm();
                setSubmitting(false);
                history.push(signInRoute);
              }
            } catch (err) {
              console.error(err);
              setSubmitting(false);
            }
          }}
        >
          {(formik) => (
            <Box
              component="form"
              onSubmit={formik.handleSubmit}
              sx={{ width: "100%", mt: 1 }}
            >
              <TextField
                margin="normal"
                required
                fullWidth
                id="email"
                name="email"
                label="Email"
                value={formik.values.email}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                error={!!formik.touched.email && !!formik.errors.email}
                helperText={
                  formik.touched.email && formik.errors.email
                    ? formik.errors.email
                    : ""
                }
                autoComplete="email"
                autoFocus
              />

              <Divider />

              <Button
                fullWidth
                type="submit"
                variant="contained"
                color="secondary"
                sx={{ mt: 2 }}
                disabled={formik.isSubmitting}
                size="large"
              >
                {formatMessage({ id: "passwordLostForm.sendMail" })}
              </Button>
              <Button
                fullWidth
                component={Link}
                to={signInRoute}
                sx={{ mt: 2 }}
                variant="outlined"
                size="large"
              >
                {formatMessage({ id: "passwordLostForm.backToSignIn" })}
              </Button>
            </Box>
          )}
        </Formik>
      </Paper>
    </Box>
  );
};

export default PasswordLostForm;
